import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Suspense as _Suspense, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" 新規登録")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Excel出力")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_tooltip = _resolveComponent("el-tooltip")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_cus_table = _resolveComponent("cus-table")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", null, [
      _createVNode(_component_el_button, {
        class: "add-button",
        type: "primary",
        icon: "el-icon-plus",
        size: "mini",
        plain: "",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openDialog(_ctx.DialogGenre.Add)))
      }, {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      }),
      _createVNode(_component_el_button, {
        class: "excel-button",
        type: "primary",
        icon: "el-icon-download",
        size: "mini",
        plain: "",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleExport2excel())),
        loading: _ctx.exportLoading
      }, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      }, 8, ["loading"])
    ]),
    _createVNode(_component_cus_table, {
      table: _ctx.table,
      tableConfig: _ctx.tableConfig,
      usePagination: false
    }, {
      append: _withCtx(() => [
        _createVNode(_component_el_table_column, { label: "操作" }, {
          default: _withCtx((scope) => [
            _createVNode(_component_el_tooltip, {
              content: "詳細",
              placement: "right",
              effect: "light"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  class: "edit-btn",
                  circle: "",
                  size: "mini",
                  onClick: ($event: any) => (_ctx.openDialog(_ctx.DialogGenre.Edit, scope.row.id)),
                  icon: "el-icon-edit",
                  plain: ""
                }, null, 8, ["onClick"])
              ]),
              _: 2
            }, 1024)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["table", "tableConfig"]),
    (_openBlock(), _createBlock(_Suspense, null, {
      default: _withCtx(() => [
        _createVNode(_component_Dialog, {
          title: _ctx.dialogTitle,
          operation: _ctx.dialogOperation,
          onSearch: _cache[3] || (_cache[3] = ($event: any) => (_ctx.getList()))
        }, null, 8, ["title", "operation"])
      ]),
      _: 1
    }))
  ]))
}